import _ from 'lodash';

class DictParser {
    static chiefComplaint(obj, sensitive) {
        if (obj && _.isObject(obj)) {
            if (obj.sensitive && sensitive) {
                return obj.sensitiveDescription ? obj.sensitiveDescription : '';
            } else {
                // return obj.__description;
                // AGL-1414 Change to ECDS descriptions not the SNOMED preferred term
                const descriptionField = obj?.ecdsVersion === 'V4' ? 'snomedPreferredTerm' : 'parentTerm';
                return !_.isNaN(parseInt(obj[descriptionField])) && Number.isInteger(parseInt(obj[descriptionField])) ? '' : obj[descriptionField];
            }
        }
        return '';
    }
}

export default DictParser;
